import template from './wizard_finsh.html';

class WizardFinishPageViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	};

	back_wizard()
	{
		Grape.dialog.open('WizardLeaveTypesEntry', {});
		this.dialog.close();
	};

	async finish_wizard()
	{
		let res = await Grape.fetches.patchJSON('/api/setting', { name: 'system.wizard', value: false });
		// ERROR
		if (res.status == 'ERROR')
		{
			Grape.alerts.apiError(res);
			return;
		}
		// SUCCESS
		Grape.navigate('/employee/create');
		this.dialog.close();
	};
};

class WizardFinishPage
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new WizardFinishPageViewModel(this);

		$.patchJSON = function(url, data, callback) {
			$.ajax({
				url: url,
				type: 'PATCH',
				contentType: 'application/json',
				data: JSON.stringify(data),
				success: callback,
				error: () => {}
			});
		};
	};
};

export default {
	name: 'WizardFinish',
	dialog_class: WizardFinishPage,
	template: template,
	template_filename: 'translation/dialogs/wizard_finsh',
	provider: 'ps'
};
